
import user_email_list from './user_email_list_dialog.js';
import report_definition from './report_definition_dialog.js';
import send_email from './send_email_dialog.js';
import auto_schedule_report from "./auto_schedule_report.js";
import auto_scheduler from "./auto_scheduler.js";
import report_notification from "./report_notification.js";
import user_email_list_send from './user-email-list-dialog.js';
import report_param from "./report_param_dialog.js";

//HELP DIALOG
import HelpDialog from './help/help.js';

export default [
	user_email_list,
	report_definition,
	send_email,
	auto_schedule_report,
	report_notification,
	user_email_list_send,
	auto_scheduler,
	report_param,
	HelpDialog
];
